import React from 'react'
import { useSelector } from 'react-redux';
import { PageSizeOptionArr } from '../_helpers/utilities';

const Pagination = ({
    PaginationPageChange,
    TotalPage = 1,
    PerPage = 10,
    CurrentPage,
    TotalItems = 0,
    PerPageSizeChangeFunc
}) => {

    const { PageSize: DefaultPageSize } = useSelector((state) => state.common);

    const pageNumbers = [...Array(TotalPage + 1).keys()].slice(1)

    const nextPage = () => {
        if (CurrentPage !== TotalPage) PaginationPageChange(CurrentPage + 1)
    }
    const prevPage = () => {
        if (CurrentPage !== 1) PaginationPageChange(CurrentPage - 1)
    }

    return (
        <div className='table-container'>
            <div className="item_PP" role="group">
                <div class="page_info">
                    <span>Per Page</span>
                    <select
                        defaultValue={DefaultPageSize}
                        onClick={(e) => PerPageSizeChangeFunc(e.target.value)}
                    >
                        {PageSizeOptionArr.map((option) => (
                            <option
                                key={option.text}
                                value={option.page}
                                className={`btn cus-btn btn-secondary`}
                            >
                                {option.text}
                            </option>
                        ))}
                    </select>
                </div>
                <span>Showing {(CurrentPage > 1 ? ((CurrentPage - 1) * PerPage) + 1 : 1)} - {CurrentPage === TotalPage ? TotalItems : CurrentPage * PerPage} of {TotalItems} Entries</span>
                <ul className='pagination cust-pagination'>
                    <li className="page-item">
                        <a className="page-link" onClick={() => PaginationPageChange(1)} href="javascript:void(0)"><i class="far fa-angle-double-left"></i></a>
                    </li>
                    <li className="page-item">
                        <a className="page-link" onClick={prevPage} href="javascript:void(0)"><i class="far fa-angle-left"></i></a>
                    </li>
                    {/* {CurrentPage > 3 && <li disabled className='page-item p-2'>
                        <a>...</a>
                    </li>} */}
                    {pageNumbers.length > 5
                        && CurrentPage > 3
                        && <li disabled className='page-item'>
                            <a onClick={() => PaginationPageChange(1)}
                                className='page-link'
                                href="javascript:void(0)">

                                {1}
                            </a>
                        </li>}
                    {pageNumbers.length > 5
                        && CurrentPage > 3
                        && <li disabled className='page-item p-2'>
                            <a>...</a>
                        </li>}
                    {pageNumbers.map(pageNumber => (
                        <>
                            {<li key={pageNumber} className={`page-item ${CurrentPage == pageNumber ? 'active' : ''} `} >
                                {/* When pagination number less then 6 */}
                                {CurrentPage < 7
                                    && pageNumbers.length < 6
                                    && pageNumber < 6
                                    && (
                                        <a onClick={() => PaginationPageChange(pageNumber)}
                                            className='page-link'
                                            href="javascript:void(0)">

                                            {pageNumber}
                                        </a>
                                    )}

                                {/* When pagination number more then 6 */}
                                {CurrentPage < 3
                                    && pageNumbers.length > 5
                                    && pageNumber < 6
                                    && (
                                        <a onClick={() => PaginationPageChange(pageNumber)}
                                            className='page-link'
                                            href="javascript:void(0)">

                                            {pageNumber}
                                        </a>
                                    )}
                                {CurrentPage >= 3
                                    && (CurrentPage < (pageNumbers.length - 3))
                                    && (pageNumber > CurrentPage - 3)
                                    && (pageNumber < CurrentPage + 3)
                                    && (
                                        <a onClick={() => PaginationPageChange(pageNumber)}
                                            className='page-link'
                                            href="javascript:void(0)">

                                            {pageNumber}
                                        </a>
                                    )}
                                {CurrentPage > pageNumbers.length - 4
                                    && pageNumbers.length > 5
                                    && pageNumber > pageNumbers.length - 5
                                    && (
                                        <a onClick={() => PaginationPageChange(pageNumber)}
                                            className='page-link'
                                            href="javascript:void(0)">

                                            {pageNumber}
                                        </a>
                                    )}
                            </li>}

                        </>
                    ))}
                    {/* {CurrentPage < (pageNumbers.length - 3) && <li disabled className='page-item p-2'>
                        <a>...</a>
                    </li>} */}
                    {pageNumbers.length > 5
                        && CurrentPage < (pageNumbers.length - 3)
                        && <li disabled className='page-item p-2'>
                            <a>...</a>
                        </li>}
                    {pageNumbers.length > 5
                        && CurrentPage < (pageNumbers.length - 3)
                        && <li disabled className='page-item'>
                            <a onClick={() => PaginationPageChange(pageNumbers.length)}
                                className='page-link'
                                href="javascript:void(0)">

                                {pageNumbers.length}
                            </a>
                        </li>}
                    <li className="page-item">
                        <a className="page-link" onClick={nextPage} href="javascript:void(0)"><i class="far fa-angle-right"></i></a>
                    </li>
                    <li className="page-item">
                        <a className="page-link" onClick={() => PaginationPageChange(pageNumbers.length)} href="javascript:void(0)"><i class="far fa-angle-double-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Pagination